export enum statusCurse{
  Active = 1,
  EndCurse = 2,
}

